// extracted by mini-css-extract-plugin
export var infoBox = "style-module--infoBox--98b4c";
export var infoBox__close = "style-module--infoBox__close--f13d0";
export var infoBox__container = "style-module--infoBox__container--1b01f";
export var infoBox__logo = "style-module--infoBox__logo--a646e";
export var infoBox__main = "style-module--infoBox__main--643ef";
export var infoBox__text = "style-module--infoBox__text--09df8";